import PageLayout from './PageLayout';

export default PageLayout;



// WEBPACK FOOTER //
// ./src/ondemand/components/PageLayout/index.js